





























import { computed, defineComponent, PropType } from 'vue';
import { iconClassEnum } from '../enums/iconClassEnum';
import Icon from './Icon.vue';
import { INFO_LINKS, InfoArea } from '../constants/infoLinks';
import { useModal } from '../composables/useModal';
import { useSpinner } from '../composables/useSpinner';

export default defineComponent({
  name: 'AulaInfoTrigger',
  components: { Icon },
  props: {
    area: { type: String as PropType<InfoArea>, default: 'HOME' },
  },
  setup(props) {
    const { isVisible, show } = useModal();
    const { isLoading, start, stop } = useSpinner();
    const infoLink = computed(() => INFO_LINKS[props.area]);

    return {
      iconClassEnum,
      isLoading,
      isVisible,
      infoLink,
      show,
      start,
      stop,
    };
  },
});
